<template>
    <div id="sidebar-wrapper" :class="{'toggle': toggle}">
        <div class="sidebar-header">
            <button class="toggle-sidebar" @click="closeMenu()">
                <i class="icon icon-times"></i>
            </button>
            
            <a href="#" class="logo-link">
                <div class="logo"></div>
            </a>

            <button class="toggle-reminders" @click="toggleReminders()">
                <i class="icon icon-bell"></i>
            </button>
        </div>

        <ul class="navigation navigation-head">
            <li @click="closeMenu()">
                <router-link to="/">
                    <i class="icon icon-home"></i>
                    <span>{{ $t('Главная') }}</span>
                </router-link>
            </li>
            <li @click="closeMenu()">
                <router-link to="/categories">
                    <i class="icon icon-categories"></i>
                    <span>{{ $t('Категории') }}</span>
                </router-link>
            </li>
            <li @click="closeMenu()">
                <router-link to="/budget">
                    <i class="icon icon-budget"></i>
                    <span>{{ $t('Бюджет') }}</span>
                </router-link>
            </li>
            <li @click="closeMenu()">
                <router-link to="/statement">
                    <i class="icon icon-transactions"></i>
                    <span>{{ $t('Операции') }}</span>
                </router-link>
            </li>
            <li @click="closeMenu()">
                <router-link to="/accounts">
                    <i class="icon icon-accounts"></i>
                    <span>{{ $t('Счета') }}</span>
                </router-link>
            </li>
            <li @click="closeMenu()">
                <router-link to="/reports">
                    <i class="icon icon-reports"></i>
                    <span>{{ $t('Отчеты') }}</span>
                </router-link>
            </li>
            <li @click="closeMenu()">
                <router-link to="/reminders">
                    <i class="icon icon-calendar"></i>
                    <span>{{ $t('Напоминания') }}</span>
                </router-link>
            </li>

            <li class="mobile-navigation">
                <a href="https://ufin.me/help" target="_blank">
                    <i class="icon icon-help"></i>
                    <span>{{ $t('Помощь') }}</span>
                </a>
            </li>
            <li class="mobile-navigation" @click="closeMenu()">
                <router-link to="/settings">
                    <i class="icon icon-cog"></i>
                    <span>{{ $t('Настройки') }}</span>
                </router-link>
            </li>
        </ul>

        <ul class="navigation navigation-foot">
            <li>
                <a href="#" @click.prevent="logout">
                    <i class="icon icon-logout"></i>
                    <span>{{ $t('Выход') }}</span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import { EventBus } from '../../event-bus';
export default {
    name: 'Sidebar',

    data: function() {
        return {
            toggle: false,
        }
    },

    mounted() {
        EventBus.$on('toggle-sidebar', () => {
            this.toggle = ! this.toggle;
        });
    },

    methods: {
        closeMenu() {
            this.toggle = false;
        },

        toggleReminders() {
            EventBus.$emit('open-side-form', 'reminders')
        },

        logout() {
            axios.post('/logout')
                .then(({data}) => {
                    this.$store.commit('logout');
                    
                    localStorage.removeItem('token');

                    delete axios.defaults.headers.common['Authorization'];

                    location.href = '/login';
                }).catch((error) => {
                    console.log(error);
                });
        },
    },
}
</script>